import { BuyerUI } from '@choco-admin/types';
import React, { useCallback } from 'react';

import { useEditBuyerMutationMutation } from '../../../../generated';
import { BuyerForm } from '../BuyerForm';
import type { BuyerFormData } from '../BuyerForm';

interface ProfileTabProps {
  buyer: BuyerUI;
}

const isValidAddressSource = (
  source: string | null | undefined
): source is 'custom' | 'google' => {
  return source === 'custom' || source === 'google';
};

export const ProfileTab: React.FC<ProfileTabProps> = ({ buyer }) => {
  const [updateBuyer] = useEditBuyerMutationMutation();

  const handleSubmit = useCallback(
    async (data: BuyerFormData) => {
      await updateBuyer({
        variables: {
          id: buyer.id,
          buyerUpdateInput: {
            name: data.name,
            displayName: data.displayName || undefined,
            fullAddress: data.fullAddress || undefined,
            deliveryComment: data.deliveryComment || undefined,
            city: data.addressCity || undefined,
            country: data.addressCountry || undefined,
            isTest: data.isTest,
            latitude: data.addressLatitude || undefined,
            longitude: data.addressLongitude || undefined,
            utcOffset: data.addressUTCOffset || undefined,
            addressSource: data.addressSource || 'custom',
          },
        },
      });
    },
    [buyer.id, updateBuyer]
  );

  const initialData = {
    name: buyer.name || '',
    displayName: buyer.displayName || '',
    fullAddress: buyer.fullAddress || '',
    deliveryComment: buyer.deliveryComment || '',
    addressCity: buyer.city || '',
    addressCountry: buyer.country || '',
    isTest: buyer.isTest || false,
    addressLatitude: buyer.latitude || undefined,
    addressLongitude: buyer.longitude || undefined,
    addressUTCOffset: buyer.utcOffset || undefined,
    addressSource: isValidAddressSource(buyer.addressSource)
      ? buyer.addressSource
      : 'custom',
  };

  return (
    <BuyerForm
      mode="edit"
      initialData={initialData}
      onSubmit={handleSubmit}
      title="Buyer Information"
    />
  );
};
